<nav class="breadcrumb" aria-label="Breadcrumb">
  @for (item of items(); track item.label; let last = $last) {
    @if (!last) {
      @if (item.routerLink) {
        <a class="breadcrumb__item breadcrumb__item--link" [routerLink]="item.routerLink">
          {{ item.label }}
        </a>
      } @else {
        <span class="breadcrumb__item breadcrumb__item--link">{{ item.label }}</span>
      }
      <mat-icon class="breadcrumb__separator" aria-hidden="true">chevron_right</mat-icon>
    } @else {
      @if (loading()) {
        <xemex-skeleton-block width="120px" height="14px" />
      } @else {
        <span class="breadcrumb__item breadcrumb__item--current" aria-current="page">
          {{ item.label }}
        </span>
      }
    }
  }
</nav>
